import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {AddressModule} from '../address-component/address.module';
import {YesNoModule} from '../yes-no-component/yes-no.module';
import {InputMaskModule} from '@ngneat/input-mask';
import {RadioOptionsComponent} from './radio-options.component';
import {AngularMaterialLibraryModule} from '../../angular-material/angular-material-library.module';
import {DirectiveLibraryModule} from '../../directives/directive-library.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        AddressModule,
        YesNoModule,
        InputMaskModule,
        AngularMaterialLibraryModule,
        DirectiveLibraryModule,
        RadioOptionsComponent
    ],
    exports: [
        RadioOptionsComponent,
    ]
})
export class RadioOptionsModule {

}
